import React from "react";
import { TableGroupProps } from "../..";
import { TableBody } from "../table-body";
import { TableHeadRow } from "../table-head-row";
import styles from "../../table.module.scss";

const TableGroup = ({ data, children }: TableGroupProps) => (
  <div className={styles.wrapper}>
    <div className={styles.scrollContainer}>
      <table className={styles.table}>
        {data ? (
          <>
            <TableHeadRow data={data} />
            <TableBody data={data} />
          </>
        ) : (
          children
        )}
      </table>
    </div>
  </div>
);

export default TableGroup;
